module.exports = __webpack_public_path__ + "img/full6-min.00f27348.png";